export const PORTAL_ROOT_ID = "wlj-portal-root";

export const PORTAL_LAYERS = {
  toast: 1400,
  modal: 1300,
  overlay: 1250,
};

export const getPortalRoot = () => {
  if (typeof document === "undefined") return null;

  let root = document.getElementById(PORTAL_ROOT_ID);
  if (!root) {
    root = document.createElement("div");
    root.id = PORTAL_ROOT_ID;
    root.setAttribute("aria-hidden", "true");
    document.body.appendChild(root);
  }

  return root;
};

export const getPortalLayerTarget = (layer = "modal") => {
  const root = getPortalRoot();
  if (!root) return null;

  const layerId = `${PORTAL_ROOT_ID}-${layer}`;
  let target = document.getElementById(layerId);

  if (!target) {
    target = document.createElement("div");
    target.id = layerId;
    target.className = "wlj-portal-layer";
    target.dataset.portalLayer = layer;
    target.style.zIndex = String(PORTAL_LAYERS[layer] ?? PORTAL_LAYERS.modal);
    root.appendChild(target);
  }

  return target;
};
